import { AxiosResponse } from "axios";
import { FilterTypeForProduct } from "../../../../Types/filterTypeForProduct";

export const areODataPropertiesAvailable = (data: AxiosResponse): boolean => {
    if (!data || !("data" in data)) {
        return false;
    }

    return "@odata.count" in data.data && "value" in data.data;
};

function modifiyDescription(item: any, index: number, arr: Array<any>) {
    item.FamilyGroupWithDescription = `${item.FamilyGroup}`;
    arr[index] = item;
}

export const getDataFromApiResponse = (data: AxiosResponse, props: FilterTypeForProduct): Array<any> | null => {
    if (areODataPropertiesAvailable(data)) {
        if (data.data["@odata.count"] === 0) {
            return data?.data?.value;
        }

        if (data.data["@odata.count"] > 0 && props.isColumnMerge) {
            data?.data?.value.forEach((item: any, index: any, arr: any) => modifiyDescription(item, index, arr));

            return data?.data?.value;
        }

        return null;
    }

    if (Array.isArray(data?.data)) {
        data?.data?.forEach((item: any, index: any, arr: any) => modifiyDescription(item, index, arr));

        return data?.data;
    }

    return null;
}